<template>
  <RadioButtons
    :activeOption="matchedContent"
    :options="options"
    @selectOption="handleOnSelectOption"
  />
</template>

<script setup lang="ts">
import type { Ref } from "vue";
import RadioButtons from "./RadioButtons.vue";
import { useRouteQuery } from "@vueuse/router";
import { ContentType } from "../constants/content-type.constant";

const matchedContent = useRouteQuery(
  "matchedContent",
  ContentType.AllMatch
) as Ref<string>;

type OptionValue = (typeof options)[number]["value"];

const options = [
  { label: "Follawed", value: ContentType.Follawed },
  { label: "Tous les matchs", value: ContentType.AllMatch },
];

const handleOnSelectOption = (value: OptionValue) => {
  if (matchedContent) {
    matchedContent.value = value;
  }
};
</script>

<style lang="scss" scoped>
.buttons-group {
  display: flex;
  flex-wrap: nowrap;
  align-self: flex-start;
  margin-top: -18px;
  /* Those have to be on the div in addition to the buttons to cover the space between the buttons */
  border-radius: 0 0 17px 17px;
  background-color: var(--clr-p2);

  :deep(.radio-button) {
    position: relative;
    border-radius: 0 0 17px 17px;
    padding: 12px 20px;
    background-color: var(--clr-p2);

    &:hover {
      box-shadow: var(--shd-button-hover);
    }

    white-space: nowrap;
    cursor: pointer;

    &.active {
      background-color: var(--clr-p8);
      border-top: 1px solid var(--clr-p8);
      box-shadow: var(--shd-button-inner);
      color: white;
    }
  }
}
</style>
